import { Button, Group, Loader, Stack, Title } from '@mantine/core';
import moment from 'moment';
import { useState } from 'react';

import { EORIGIN_DATE_FORMAT } from '@e-origin/shared';

import { DatePickerInput } from '@components';
import { useGenerateDailyReport } from '@hooks/declaration';

interface DailyReportProps {
  title: string;
}

export const DailyReport: React.FC<DailyReportProps> = ({ title }) => {
  const [date, setDate] = useState(moment().toDate());

  const generateDailyReportMutation = useGenerateDailyReport();

  const [isLoading, setIsLoading] = useState(false);

  const handleDownloadReport = async () => {
    setIsLoading(true);
    await generateDailyReportMutation.mutateAsync({ date: moment(date).format(EORIGIN_DATE_FORMAT) });
    setIsLoading(false);
  };

  return (
    <Stack gap="xl">
      <Title order={2}>{title}</Title>

      <DatePickerInput label="Date of validity" value={date} onChange={(value: Date) => setDate(value)} clearable={true} />

      <Group>
        <Button leftSection={isLoading && <Loader color="#FFFFFF" />} onClick={handleDownloadReport} disabled={isLoading} variant="filled" size="lg">
          {isLoading ? 'Generating report..' : 'Generate report'}
        </Button>
      </Group>
    </Stack>
  );
};
